module.exports = __webpack_public_path__ + "components/country-flag/static/co-35526e3fa008593056b6e8eca3c9c8f3.svg";